/**
 * Page Description Read More/Less Toggle
 * Clips long descriptions to 3 lines and adds a read more/less button
 */

document.addEventListener('DOMContentLoaded', () => {
	const descriptions = document.querySelectorAll('[data-page-description]');

	descriptions.forEach((container) => {
		const content = container.querySelector('.site-page__description-content');
		const faqLink = container.querySelector('.site-page__description-faq-link');

		if (!content && !faqLink) return;

		const actions = document.createElement('div');
		actions.className = 'site-page__description-actions';
		container.appendChild(actions);

		let toggleBtn = null;

		if (content) {
			const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
			const maxHeight = lineHeight * 3;

			container.classList.remove('is-clamped');
			const fullHeight = content.scrollHeight;

			if (fullHeight > maxHeight + 5) {
				container.classList.add('is-clamped');

				toggleBtn = document.createElement('button');
				toggleBtn.className = 'site-page__description-toggle';
				toggleBtn.setAttribute('type', 'button');
				toggleBtn.setAttribute('aria-expanded', 'false');
				toggleBtn.textContent = 'Read more';

				actions.appendChild(toggleBtn);

				toggleBtn.addEventListener('click', () => {
					const isExpanded = container.classList.contains('is-expanded');

					container.classList.toggle('is-expanded', !isExpanded);
					container.classList.toggle('is-clamped', isExpanded);

					toggleBtn.textContent = isExpanded ? 'Read more' : 'Read less';
					toggleBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
				});
			}
		}

		if (faqLink) {
			actions.appendChild(faqLink);
		}

		if (!actions.children.length) {
			actions.remove();
		}
	});
});